import { computed, makeAutoObservable, observable } from "mobx";
import ProductModel from "../stores/ProductModel";
import OptionModel from "./OptionModel";

export {
    MATTRESS_HARDNESS_OPTION_ID,
    MATTRESS_SIZE_OPTION_ID,
} from "../utils/ConfigurationOptions";

export class ProductConfigurationOptionDataType {
    required: boolean;
    stock: boolean;
    values: Array<ProductConfigurationOptionValueData>;
    id: number;
    name: string;
    type: string;
    order: number;

}

export class ProductConfigurationOptionValueData {
    id: number;
    order: number;
    name: string;

}

export default class ProductConfigurationOption {
    product: ProductModel;
    type = 'select';
    @observable data: ProductConfigurationOptionDataType = {};
    @observable id = null;
    @observable order = 1;
    @observable options:OptionModel[] = [];
    @observable value = null;

    constructor({ product, ...props }) {

        makeAutoObservable(this);

        if (!product) {
            throw Error(`product is undefined`);
        }
        this.product = product;

        this.fromJSON(props);
    }
    @computed get required() {
        if(this.data.required !== undefined) {
            return this.data.required
        }
        return true;
    }

    @computed get halfSizeOptions() {
        return this.options.filter((o) => o.halfSize);
    }

    @computed get selectedOption(){
        return this.options.find((o) => o.valueId === this.value);
    }

    @computed get stepType(){
        const found = this.step;
        if(found?.type){
            return found.type;
        }
        return null;
    }
    @computed get name(){
        if(this.data?.name){
            return this.data.name;
        }
        return null;
    }

    // step.name
    @computed get stepName(){
        const found = this.step;
        if(found?.name){
            return found.name;
        }
        return null;
    }

    @computed get step(){
        const found = this.product.store.sortedStepsFlat.find((step) => step.id === this.id);
        if(found){
            return found;
        }
        return null;
    }
    @computed get change_model_view(){
        if(this.step){
            return this.step.change_model_view
        }
        return false;
    }
    // prefix_option
    @computed get prefix_option(){
        if(this.step){
            return this.step.prefix_option
        }
        return false;
    }


    // prefix_value
    @computed get prefix_value(){
        if(this.step){
            return this.step.prefix_value
        }
        return false;
    }



    /**
     * 
     * @param {ProductConfigurationOptionDataType} props 
     */
    fromJSON(props) {
        this.data = props;
        this.id = parseInt(props.id);
        this.order = parseInt(props.order);
        this.type = props.type;

        if (this.data.values) {
            this.options = this.data.values.map((optionData) => {
                return new OptionModel({
                    configurationOption: this,
                    ...optionData,
                });
            });

        }
        if(this.type === 'checkbox'){
            this.value = false;
        }
    }
}